import {
  getSandboxFeatureAccess,
  isSandboxCompany,
} from "helpers/sandboxAccess";

export const selectCurrentUser = (state) => state.user?.user;

export const selectIsSandboxEnvironment = (state) => {
  const user = selectCurrentUser(state);
  const companyFlag = user?.company?.is_sandbox;

  if (companyFlag === true || companyFlag === false) {
    return isSandboxCompany(user);
  }

  return Boolean(state.sandbox?.isSandboxSession);
};

export const selectSandboxLiveCompanyId = (state) =>
  selectCurrentUser(state)?.company?.sandbox_of ?? null;

export const makeSelectSandboxFeatureAccess = (feature) => (state) =>
  getSandboxFeatureAccess(feature, selectIsSandboxEnvironment(state));
